export default "__VITE_ASSET__e9OahzhB__"